<template>
  <div
    class="tag-input"
    :class="{ 'tag-input--max-reached': isMaxReached }"
    @click="focusOnInput"
  >
    <ElTag
      v-for="item in items"
      :key="item"
      closable
      size="small"
      class="tag-input__item"
      disable-transitions
      @click.stop
      @close="removeItem(item)"
    >
      {{ item }}
    </ElTag>
    <input
      v-show="!isMaxReached"
      ref="input"
      v-model.trim="inputValue"
      class="tag-input__input"
      type="text"
      :placeholder="placeholderEmptyItems"
      @keydown.enter.prevent="checkLimitAndAddItem"
    />
  </div>
</template>

<script>
export default {
  name: 'TagInput',
  model: {
    prop: 'items',
    event: 'input',
  },
  props: {
    items: {
      required: true,
      type: Array,
    },
    placeholder: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      inputValue: '',
    };
  },
  computed: {
    placeholderEmptyItems() {
      return this.items.length === 0 ? this.placeholder : '';
    },
    isMaxReached() {
      if (this.max === 0) return false;

      return this.items.length >= this.max;
    },
  },
  methods: {
    focusOnInput() {
      this.$refs.input.focus();
    },
    emitNewItems(items) {
      this.$emit('input', items);
    },
    checkLimitAndAddItem() {
      if (this.isMaxReached) return false;

      this.addItem();
    },
    addItem() {
      if (this.inputValue && !this.items.includes(this.inputValue)) {
        this.emitNewItems([...this.items, this.inputValue]);
        this.inputValue = '';
      }
    },
    removeItem(itemToRemove) {
      this.emitNewItems(this.items.filter(item => item !== itemToRemove));
    },
  },
};
</script>

<style lang="scss">
.tag-input {
  $margin-insider-vertical: rem-calc(2px);

  font-size: $--input-font-size;
  color: $--input-font-color;
  width: $--input-width;
  min-height: $--input-height;
  border: $--input-border;
  border-color: $--input-border-color;
  background-color: $--input-background-color;
  border-radius: $--border-radius-base;

  padding: #{$global-padding * 0.4375 - $margin-insider-vertical} $global-padding;

  display: flex;
  align-items: center;
  flex-wrap: wrap;

  cursor: text;

  &--max-reached {
    cursor: not-allowed;
  }

  &:hover {
    border-color: $--input-border-color-hover;
  }

  &__item {
    background-color: $--background-color-base;
    border: 1px solid $--border-color-base;

    color: $--color-text-regular;

    margin-top: $margin-insider-vertical;
    margin-bottom: $margin-insider-vertical;

    cursor: auto;

    &:not(:last-child) {
      margin-right: 6px;
      margin-left: 0;
      @include rtl() {
        margin-left: 6px;
        margin-right: 0;
      }
    }

    .el-tag__close {
      color: $lb-darker-gray;
      font-weight: bold;

      &:hover {
        background-color: transparent;
        color: $lb-darker-gray;
      }
    }
  }

  &__item + &__input {
    margin-right: calc($global-margin / 2);
  }

  &__input {
    min-width: 0;
    flex-basis: rem-calc(30px);
    width: auto;
    flex-grow: 1;
    border: 0;

    padding: 0;

    height: 24px; // to be the same as small el tag

    margin-top: $margin-insider-vertical;
    margin-bottom: $margin-insider-vertical;

    &:hover {
      border: 0;
    }

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: $--input-placeholder-color;
    }
  }
}
</style>
